import React from 'react';

const HeaderImageAndCard = ({children, image}) => {

    return <div className="relative shrink-0">
        <div className="bg-gray-400 w-full h-[25vh] bg-cover bg-center relative overflow-hidden" style={{backgroundImage: `url(${image})`}}>
            <div className="ml-[5%] w-[90%] lg:w-[75%] lg:mx-[12.5%] rounded-tl-lg rounded-tr-lg h-[4rem] absolute bottom-0"
                style={{boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.25)'}}
            />
        </div>
        <div className="mx-auto w-[90%] lg:w-[75%] rounded-tl-lg rounded-tr-lg p-4 pb-0 bg-white mt-[-4rem] min-h-[4rem] relative">
            {children}
        </div>
    </div>;

}

export default HeaderImageAndCard;